import axios from "@/api/request"
import { plainToInstance } from 'class-transformer';
import { mybatisplusPage } from '@suc/nomos-lint';
import { PrincipalInfoVO } from './models/PrincipalInfoVO';
import { Page } from './models/Page';
import { PrincipalInfoDTO } from './models/PrincipalInfoDTO';

/**
* @NomosController
* @NomosDefinePackageName com.sucsoft.organization.basic.management.server.controller
* @NomosDefineClassName PrincipalInfoController
*/
export class PrincipalInfoController {

    /**
     * @NomosDefinePath /api/organization/management/server/principalInfo/list
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName getList
     * @NomosDefineParameters [{"name":"principalType","type":{"family":"string"},"required":false,"isRequestBody":false,"description":null}]
     * @NomosDefineSuccessResponse java.util.List<com.sucsoft.organization.basic.management.commons.vo.PrincipalInfoVO>
     * @NomosDefineDescription "[组织管理-生产经营主体信息]API-2-主体信息-列表查询"
     * @NomosDefinePathStyle NORMAL
     */
    getList(params: { "principalType"?: string }) {
        const url = '/api/organization/management/server/principalInfo/list';
        return axios
            .get<any[]>(url, {params})
            .then(({data}) => plainToInstance(PrincipalInfoVO, data));
    }

    /**
     * @NomosDefinePath /api/organization/management/server/principalInfo/page/{pageNum}/{pageSize}
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName getByPage
     * @NomosDefineParameters [{"name":"pageNum","type":{"family":"number"},"required":true,"isRequestBody":false,"description":"页码"},{"name":"pageSize","type":{"family":"number"},"required":true,"isRequestBody":false,"description":"显示数量"},{"name":"keyword","type":{"family":"string"},"required":false,"isRequestBody":false,"description":"模糊查询(品类名称)"},{"name":"principalType","type":{"family":"string"},"required":false,"isRequestBody":false,"description":"主体类型(production生产经营主体/government政府)"}]
     * @NomosDefineSuccessResponse com.baomidou.mybatisplus.extension.plugins.pagination.Page<com.sucsoft.organization.basic.management.commons.vo.PrincipalInfoVO>
     * @NomosDefineDescription "[组织管理-生产经营主体信息]API-1-主体信息-列表（分页）"
     * @NomosDefinePathStyle NORMAL
     */
    getByPage(params: { "pageNum": number, "pageSize": number, "keyword"?: string, "principalType"?: string }) {
        const url = `/api/organization/management/server/principalInfo/page/${params["pageNum"]}/${params["pageSize"]}`;
        return axios
            .get<any>(url, {params})
            .then(({data}) => plainToInstance<Page<PrincipalInfoVO>,any>(Page, data));
    }

    /**
     * @NomosDefinePath /api/organization/management/server/principalInfo
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod DELETE
     * @NomosDefineRequestType json
     * @NomosDefineMethodName removeById
     * @NomosDefineParameters [{"name":"ids","type":{"family":"array","elementType":{"family":"string"}},"required":true,"isRequestBody":true,"description":null}]
     * @NomosDefineSuccessResponse boolean
     * @NomosDefineDescription "[组织管理-生产经营主体信息]API-6-根据id删除-主体信息"
     * @NomosDefinePathStyle NORMAL
     */
    removeById(ids: Array<string>) {
        const url = '/api/organization/management/server/principalInfo';
        return axios
            .delete<boolean>(url, {data: ids})
            .then(({data}) => data);
    }

    /**
     * @NomosDefinePath /api/organization/management/server/principalInfo
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod POST
     * @NomosDefineRequestType json
     * @NomosDefineMethodName save
     * @NomosDefineParameters [{"name":"principalInfo","type":{"family":"object","className":"com.sucsoft.organization.basic.management.commons.dto.PrincipalInfoDTO","elementTypes":[]},"required":true,"isRequestBody":true,"description":null}]
     * @NomosDefineSuccessResponse void
     * @NomosDefineDescription "[组织管理-生产经营主体信息]API-4-新增-主体信息"
     * @NomosDefinePathStyle NORMAL
     */
    save(principalInfo: PrincipalInfoDTO) {
        const url = '/api/organization/management/server/principalInfo';
        return axios
            .post<void>(url, principalInfo, {})
            .then(({data}) => data);
    }

    /**
     * @NomosDefinePath /api/organization/management/server/principalInfo
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod PUT
     * @NomosDefineRequestType json
     * @NomosDefineMethodName update
     * @NomosDefineParameters [{"name":"principalInfo","type":{"family":"object","className":"com.sucsoft.organization.basic.management.commons.vo.PrincipalInfoVO","elementTypes":[]},"required":true,"isRequestBody":true,"description":null}]
     * @NomosDefineSuccessResponse void
     * @NomosDefineDescription "[组织管理-生产经营主体信息]API-5-修改-主体信息"
     * @NomosDefinePathStyle NORMAL
     */
    update(principalInfo: PrincipalInfoVO) {
        const url = '/api/organization/management/server/principalInfo';
        return axios
            .put<void>(url, principalInfo, {})
            .then(({data}) => data);
    }

    /**
     * @NomosDefinePath /api/organization/management/server/principalInfo/{id}
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName getById
     * @NomosDefineParameters [{"name":"id","type":{"family":"string"},"required":true,"isRequestBody":false,"description":null}]
     * @NomosDefineSuccessResponse com.sucsoft.organization.basic.management.commons.vo.PrincipalInfoVO
     * @NomosDefineDescription "[组织管理-生产经营主体信息]API-3-主体信息-详情"
     * @NomosDefinePathStyle NORMAL
     */
    getById(id: string) {
        const url = `/api/organization/management/server/principalInfo/${id}`;
        return axios
            .get<any>(url, {params: {id}})
            .then(({data}) => plainToInstance(PrincipalInfoVO, data));
    }

}

export const principalInfoController = new PrincipalInfoController();
